<template>
  <li class="news-item" v-if="item !== null">
    <router-link :to="{ name: 'single-news', params: { uuid: item.id } }" class="content-container">
      <div class="thumbnail-container" v-if="item.title && item.image_url">
        <img v-lazy="$options.filters.imageproxy(item.image_url, 500)" :alt="`${item.title} - Thumbnail`" class="">
      </div>
      <div class="post-date" v-if="item.post_date">{{ formatted_post_date }}</div>
      <h2 class="post-title" v-if="item.title">{{ item.title }}</h2>
      <p class="post-excerpt">{{ item.content | sanitized }}</p>
    </router-link>
    <router-link :to="{ name: 'single-news', params: { uuid: item.id } }" class="button btn-with-icon">
      Mehr dazu
      <img src="@/assets/svgs/2024/icons/arrow-big.svg">
    </router-link>

  </li>
</template>

<script>
import moment from 'moment';

export default {
  name: 'NewsItem',
  props: {
    item: {
      type: Object,
      default() {
        return null
      }
    }
  },
  filters: {
    sanitized: (value) => {
      // console.log('x1', value);
      if (!value) return ''
      let shortString = value.replace(/<\/?[^>]+(>|$)/g, "")
      // console.log('x2', shortString);
      shortString = shortString.replace(/&nbsp;/g, "") // replace the &nbsp;
      // console.log('x3', shortString);
      return shortString.substring(0, 100) + '...'
    }
  },
  computed: {
    formatted_post_date() {
      if (this.item === null)
        return null
      return moment(this.item.post_date).format('DD.MM.YYYY')
    }
  },
  mounted() {
  },
}
</script>

<style lang="scss" scoped>
.news-item {
  padding: 1rem;
  margin-top: 1rem;
  text-align: left;
  background-color: $white;

  .thumbnail-container {
    position: relative;
    width: 100%;
    margin-bottom: .5rem;
    overflow: hidden;
    border-radius: rem-calc(3);

    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;

    img {
      width: 100%;
      border-radius: rem-calc(3);
      height: 350px;
      object-fit: cover;

      @include breakpoint(large) {
        height: 226px;
      }
    }
  }
  .content-container {
    color: $black;
    overflow: hidden;

    .post-date {
      font-size: 1rem;
      margin: 1.5rem 0;
      color: $dark-gray;
    }

    .post-title {
      margin-bottom: .5rem;
      color: $dark-gray;
      font-size: 1.5rem;
      font-weight: bold;
    }

    .post-excerpt {
      margin: 0;
      overflow: hidden;
      word-break: break-word;
    }
  }

  .button.btn-with-icon {
    max-width: 160px;
    margin-left: auto;
    margin-top: 1rem;
  }
}
</style>